<template>
    <span
        class="left-handed-icon-wrap"
        title="Left-handed techniques"
        @mouseenter="showTooltip"
        @mouseleave="hideTooltip">
        <img
            src="/images/left-handed.png"
            alt="Left-handed techniques"
            class="left-handed-icon"
            width="20"
            height="20"/>
    </span>
</template>

<script>
export default {
    name: 'LeftHandedIcon',

    methods: {
        showTooltip(event) {
            const link = event.currentTarget.closest('a[title]');

            if (!link) {
                return;
            }

            link.dataset.mmctsSavedTitle = link.getAttribute('title') || '';
            link.removeAttribute('title');
        },
        hideTooltip(event) {
            const link = event.currentTarget.closest('a');

            if (!link || link.dataset.mmctsSavedTitle === undefined) {
                return;
            }

            const savedTitle = link.dataset.mmctsSavedTitle;

            if (savedTitle) {
                link.setAttribute('title', savedTitle);
            }

            delete link.dataset.mmctsSavedTitle;
        },
    },
};
</script>

<style scoped>
.left-handed-icon-wrap {
    display: inline-block;
    vertical-align: text-top;
    margin-left: 0.25rem;
}

.left-handed-icon {
    display: block;
    vertical-align: text-top;
}
</style>
